import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import login from '@/components/login'
import register from '@/components/register'
import about from '@/components/about'
import evaluation from '@/components/importHoldings'
import forgotpassword from '@/components/forgotpassword'
import contactus from '@/components/contactus'
import privacypolicy from '@/components/privacypolicy'
import legalagreement from '@/components/legalagreement'
import marketsmithindia from '@/components/marketsmithindia'
import plandetails from '@/components/plandetails'
import plandetailsnew from '@/components/plandetailsnew'
import faqs from '@/components/faqs'
import paymentfailure from '@/components/paymentfailure'
import paymenterror from '@/components/paymenterror'
import paymentsuccess from '@/components/paymentsuccess'
import paymentcomplete from '@/components/paymentcomplete'
import reports from '@/components/reports'
import account from '@/components/account'
import useraccount from '@/components/useraccount'
import dashboard from '@/components/Dashboard'
import paymentredirect from '@/components/paymentredirect'
import preevaluation from '@/components/preevaluation'
import more from '@/components/more'
import psiverify from '@/components/psiverify';
import newevaluation from '@/components/newevaluation'
// import psihome from '@/components/psihome';
import adminregister from '@/components/adminregister'
import partnerbrokeradmin from '@/components/PartnerBrokerAdminTabs'
import { auth } from 'firebase'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: '/home/'
    },
    {
      path: "/home/",
      name: "home",
      component: home
    },
    {
      path: "/login/:id",
      name: "login",
      component: login
    },
    {
      path: "/about/",
      name: "about",
      component: about
    },
    {
      path: "/evaluation/",
      name: "evaluation",
      component: evaluation
    },
    {
      path: "/newevaluation/",
      name: "newevaluation",
      component: newevaluation
    },
    {
      path: "/register/",
      name: "register",
      component: register
    },
    {
      path: "/dashboard/",
      name: "dashboard",
      component: dashboard
    },
    {
      path: "/paymentredirect/",
      name: "paymentredirect",
      component: paymentredirect
    },
    {
      path: "/forgotpassword/",
      name: "forgotpassword",
      component: forgotpassword
    },
    {
      path: '/psiverify/',
      component: psiverify,
      name: 'psiverify'
    },
    {
      path: "/contactus/",
      name: "contactus",
      component: contactus
    },
    {
      path: "/privacypolicy/",
      name: "privacypolicy",
      component: privacypolicy
    },
    {
      path: "/legalagreement/",
      name: "legalagreement",
      component: legalagreement
    },
    {
      path: "/marketsmithindia/",
      name: "marketsmithindia",
      component: marketsmithindia
    },
    {
      path: "/plandetails/",
      name: "plandetails",
      component: plandetails
    },{
      path: "/plandetailsnew/",
      name: "plandetailsnew",
      component: plandetailsnew
    },
    {
      path: "/faqs/",
      name: "faqs",
      component: faqs
    },
    {
      path: "/paymentfailure/",
      name: "paymentfailure",
      component: paymentfailure
    },
    {
      path: "/paymentsuccess/",
      name: "paymentsuccess",
      component: paymentsuccess
    },{
      path: "/paymenterror/",
      name: "paymenterror",
      component: paymenterror
    },
    {
      path: "/paymentcomplete/",
      name: "paymentcomplete",
      component: paymentcomplete
    },
    {
      path: "/reports/",
      name: "reports",
      component: reports
    },
    {
      path: "/account/",
      name: "account",
      component: account
    },
    {
      path: "/useraccount/",
      name: "useraccount",
      component: useraccount
    },
    {
      path: "/preevaluation/",
      name: "preevaluation",
      component: preevaluation
    },
    {
      path: "/more/",
      name: "more",
      component: more
    },
    {
      path:"/adminregister/",
      name:"adminregister",
      component:adminregister
    },
    {
      path: "/partnerbrokeradmin/",
      name: "partnerbrokeradmin",
      component: partnerbrokeradmin
    },
    {
      path: "/msievaluation/",
      name: "msievaluation",
      component: evaluation
    }
  ]
})

const openRoutes = [
  "login",
  "forgotpassword",
  "register",
  "about",
  "contactus",
  "home",
  "legalagreement",
  "privacypolicy",
  "contactus",
  "marketsmithindia",
  "faqs",
  "preevaluation",
  "more",
  "psiverify",
  "useraccount",
  "partnerbrokeradmin",
  "msievaluation"
];

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/pagenotfound/');
  } else {
    next();
  }
  if (
    localStorage.getItem("psitoken") &&
    (to.path === "/register/" ||
      to.path === "/login" ||
      to.path === "/forgotpassword/" ||
      to.path === "/home/")
  ) {
    next(false);
  }
  if (
    localStorage.getItem("psitoken") &&
    (to.path === "/" ||
      to.path === "/home/" ||
      to.path == "/login/" ||
      to.path == "/login" ||
      to.path == "/register/" ||
      to.path == "/register" ||
      to.path == "/forgotpassword/" ||
      to.path == "/forgotpassword" ||
      to.path == "/marketsmithindia/" ||
      to.path == "/marketsmithindia"
    )
  ) {
    next("/evaluation");
  } else if (
    !localStorage.getItem("psitoken") &&
    !openRoutes.includes(to.name)
  ) {
    next({name: "login"})
    localStorage.setItem("redirectpath", to.path)
  }
  else if (
    !localStorage.getItem("psitoken") && to.query.utm_source == "MSI"
  ) {
    localStorage.setItem("isMSIUser", true);
    //Set access token
    localStorage.setItem("access_token",to.query.accesstoken);
    localStorage.setItem("psitoken", to.query.accesstoken);
    localStorage.setItem("memberId", to.query.memberid);
    localStorage.setItem("msauth", to.query.msauth);
    localStorage.setItem("selectedPortfolioId", to.query.portfolioId);
    localStorage.setItem("isPremium",to.query.isPremium);
  } else {
    next();
  }
}
);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js